(function(){
    let guidePupopScrollY = 0;

    function guidePupopPadTargets() {
        return [
            document.documentElement,
            document.body,
            document.querySelector('.shopify-section-group-header-group')
        ].filter(Boolean);
    }

    function lockGuidePupopScroll() {
        if (document.documentElement.classList.contains('guide-pupop-open')) return;
        guidePupopScrollY = window.scrollY || window.pageYOffset || 0;
        var scrollbarGap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        document.documentElement.classList.add('guide-pupop-open');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        // Keep layout width when scrollbar disappears (avoids sticky PDP column jump).
        if (scrollbarGap > 0) {
            var pad = scrollbarGap + 'px';
            guidePupopPadTargets().forEach(function (el) {
                el.style.paddingRight = pad;
            });
        }
    }

    function unlockGuidePupopScroll() {
        if (!document.documentElement.classList.contains('guide-pupop-open')) return;
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        guidePupopPadTargets().forEach(function (el) {
            el.style.paddingRight = '';
        });
        document.documentElement.classList.remove('guide-pupop-open');
        window.scrollTo(0, guidePupopScrollY || 0);
    }

    function closeGuidePupop() {
        var boxes = document.querySelectorAll('.guide-pupop-box');
        var visible = false;
        boxes.forEach(function (el) {
            if (window.getComputedStyle(el).display !== 'none') visible = true;
        });
        if (!visible && !document.documentElement.classList.contains('guide-pupop-open')) return;
        unlockGuidePupopScroll();
        if (window.jQuery) {
            window.jQuery('.guide-pupop-box').stop(true, true).hide();
        } else {
            boxes.forEach(function (el) {
                el.style.display = 'none';
                el.style.opacity = '';
            });
        }
    }

    document.addEventListener('click', function (e) {
        var icon = e.target.closest && e.target.closest('.guide-pupop .c-pupop-header-icon');
        if (icon) {
            e.preventDefault();
            closeGuidePupop();
            return;
        }
        if (e.target.classList && e.target.classList.contains('guide-pupop')) {
            closeGuidePupop();
        }
    });

    document.addEventListener('touchend', function (e) {
        if (window.innerWidth >= 1000) return;
        if (!document.documentElement.classList.contains('guide-pupop-open')) return;
        var icon = e.target.closest && e.target.closest('.guide-pupop .c-pupop-header-icon');
        if (!icon && !(e.target.classList && e.target.classList.contains('guide-pupop'))) return;
        e.preventDefault();
        closeGuidePupop();
    });

    window.unlockGuidePupopScroll = unlockGuidePupopScroll;
    window.lockGuidePupopScroll = lockGuidePupopScroll;
    window.closeGuidePupop = closeGuidePupop;

    function normalizeGuideText(text) {
        return (text || '').replace(/\s+/g, ' ').trim();
    }

    function getTextBeforeNode(node) {
        var text = '';
        var cur = node.previousSibling;
        while (cur) {
            if (cur.nodeType === 3) {
                text = cur.textContent + text;
            } else if (cur.nodeType === 1) {
                if (cur.tagName === 'BR' || (cur.classList && cur.classList.contains('guide_pupop_size_image_text_br'))) {
                    break;
                }
                text = (cur.textContent || '') + text;
            }
            cur = cur.previousSibling;
        }
        return normalizeGuideText(text);
    }

    function isMeasurementTitleLine(text) {
        var t = normalizeGuideText(text);
        if (!t || t.length > 48) {
            return false;
        }
        if (/[.!?]$/.test(t)) {
            return false;
        }
        if (!/[A-Za-z]/.test(t)) {
            return false;
        }
        return t === t.toUpperCase();
    }

    function getTextAfterNode(node) {
        var text = '';
        var cur = node.nextSibling;
        while (cur) {
            if (cur.nodeType === 3) {
                text += cur.textContent;
            } else if (cur.nodeType === 1) {
                if (cur.tagName === 'BR' || (cur.classList && cur.classList.contains('guide_pupop_size_image_text_br'))) {
                    break;
                }
                text += cur.textContent || '';
            }
            cur = cur.nextSibling;
        }
        return normalizeGuideText(text);
    }

    function isDisclaimerParagraph(el) {
        var t = normalizeGuideText(el.innerText || el.textContent);
        if (!t) {
            return false;
        }
        if (/FRONT LENGTH|BACK LENGTH|SLEEVE LENGTH|HEM CIRCUMFERENCE|SHOULDER WIDTH|THIGH CIRCUMFERENCE|SKIRT LENGTH|FRONT RISE|RAGLAN/i.test(t)) {
            return false;
        }
        if (isMeasurementTitleLine(t.split('\n')[0]) && t.indexOf('\n') >= 0) {
            return false;
        }
        if (isMeasurementTitleLine(t) && t.indexOf('\n') < 0) {
            return false;
        }
        if (/^all measurements are taken/i.test(t)) {
            return true;
        }
        if (/^measurements are intended/i.test(t)) {
            return true;
        }
        return false;
    }

    function getBlockChildren(field) {
        return Array.prototype.filter.call(field.children, function (el) {
            return el.nodeType === 1 && /^(P|H[1-6])$/i.test(el.tagName);
        });
    }

    function mergeDisclaimerParagraphs(field) {
        var blockChildren = getBlockChildren(field);
        var i = 0;
        while (i < blockChildren.length - 1) {
            var current = blockChildren[i];
            var next = blockChildren[i + 1];
            if (!(isDisclaimerParagraph(current) && isDisclaimerParagraph(next))) {
                break;
            }
            var tail = normalizeGuideText(current.textContent);
            var head = normalizeGuideText(next.textContent);
            if (tail && head && !/[\s]$/.test(current.textContent) && !/^[.,!?;:]/.test(head)) {
                current.appendChild(document.createTextNode(' '));
            }
            while (next.firstChild) {
                current.appendChild(next.firstChild);
            }
            next.parentNode.removeChild(next);
            current.classList.add('guide_pupop_size_image_text_disclaimer');
            blockChildren = getBlockChildren(field);
        }
        blockChildren = getBlockChildren(field);
        if (blockChildren[0] && isDisclaimerParagraph(blockChildren[0])) {
            blockChildren[0].classList.add('guide_pupop_size_image_text_disclaimer');
        }
    }

    function isDisclaimerSoftBreak(br) {
        var before = getTextBeforeNode(br);
        var after = getTextAfterNode(br);
        if (!before || !after) {
            return false;
        }
        if (/^all measurements are taken/i.test(before) && /[.!?]$/.test(before) && /^measurements are intended/i.test(after)) {
            return true;
        }
        if (/^measurements are intended/i.test(before) && /[.!?]$/.test(before) && /^all measurements are taken/i.test(after)) {
            return true;
        }
        return false;
    }

    function wrapMeasurementTitleLines(root) {
        root.querySelectorAll('.guide_pupop_size_image_text_br').forEach(function (span) {
            if (!span.parentNode) {
                return;
            }
            var prev = span.previousSibling;
            while (prev && prev.nodeType === 3 && !normalizeGuideText(prev.textContent)) {
                prev = prev.previousSibling;
            }
            if (!prev) {
                return;
            }
            if (prev.nodeType === 3 && isMeasurementTitleLine(prev.textContent)) {
                var titleSpan = document.createElement('span');
                titleSpan.className = 'guide_pupop_size_image_text_title';
                prev.parentNode.insertBefore(titleSpan, prev);
                titleSpan.appendChild(prev);
                return;
            }
            if (
                prev.nodeType === 1 &&
                prev.classList &&
                !prev.classList.contains('guide_pupop_size_image_text_title') &&
                !prev.classList.contains('guide_pupop_size_image_text_br') &&
                !prev.classList.contains('guide_pupop_size_image_text_gap') &&
                isMeasurementTitleLine(prev.textContent)
            ) {
                prev.classList.add('guide_pupop_size_image_text_title');
            }
        });
        var field = root.querySelector('.metafield-rich_text_field') || root;
        getBlockChildren(field).forEach(function (block) {
            if (block.classList.contains('guide_pupop_size_image_text_disclaimer')) {
                return;
            }
            if (block.querySelector('.guide_pupop_size_image_text_title')) {
                return;
            }
            if (
                isMeasurementTitleLine(block.textContent) &&
                !block.querySelector('.guide_pupop_size_image_text_br, .guide_pupop_size_image_text_gap')
            ) {
                block.classList.add('guide_pupop_size_image_text_title');
            }
        });
    }

    window.updateGuideFitAxisLabels = function updateGuideFitAxisLabels(scope) {
        var roots = scope
            ? [scope]
            : Array.prototype.slice.call(document.querySelectorAll('.guide_pupop_content-gui_pupop_tab3'));
        roots.forEach(function (root) {
            if (!root || !root.querySelector) {
                return;
            }
            var labelEl = root.querySelector('.guide_pupop_fit_axis_bust_label'); 
            if (!labelEl) {
                return;
            }
            var showIn = root.classList.contains('guide_pupop_fit_show_in');
            var table = root.querySelector(
                showIn
                    ? '.guide_pupop_fit_details_in table'
                    : '.guide_pupop_fit_details_cm table'
            );
            if (!table) {
                table = root.querySelector('.guide_pupop_fit_details_cm table, .guide_pupop_fit_details_in table');
            }
            if (!table) {
                return;
            }
            var cell = table.querySelector(
                'thead tr:first-child th:first-child, thead tr:first-child td:first-child, tr:first-child th:first-child, tr:first-child td:first-child'
            );
            if (!cell) {
                return;
            }
            var label = (cell.textContent || '')
                .replace(/\s*\(\s*(cm|in)\s*\)\s*/gi, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            if (!label || /^\d/.test(label) || label === '/' || label === '-') {
                return;
            }
            labelEl.textContent = label;
        });
    };

    window.formatGuideSizeImageText = function formatGuideSizeImageText() {
        $('.guide_pupop_size_image_text').each(function () {
            var root = this;
            if (root.getAttribute('data-guide-spaced') === '3') {
                return;
            }
            var field = root.querySelector('.metafield-rich_text_field') || root;
            if (root.getAttribute('data-guide-spaced') === '1' || root.getAttribute('data-guide-spaced') === '2') {
                root.querySelectorAll('.guide_pupop_size_image_text_br').forEach(function (el) {
                    el.style.height = '';
                    el.style.minHeight = '';
                    el.style.lineHeight = '';
                });
            }
            if (!root.getAttribute('data-guide-spaced') || root.getAttribute('data-guide-spaced') === '1') {
                mergeDisclaimerParagraphs(field);
                root.querySelectorAll('br').forEach(function (br) {
                    if (!br.parentNode) {
                        return;
                    }
                    if (isDisclaimerSoftBreak(br)) {
                        br.parentNode.replaceChild(document.createTextNode(' '), br);
                        return;
                    }
                    var before = getTextBeforeNode(br);
                    var after = getTextAfterNode(br);
                    if (isMeasurementTitleLine(before)) {
                        var titleGap = document.createElement('span');
                        titleGap.className = 'guide_pupop_size_image_text_br';
                        titleGap.setAttribute('aria-hidden', 'true');
                        br.parentNode.replaceChild(titleGap, br);
                        return;
                    }
                    if (isMeasurementTitleLine(after)) {
                        var prev = br.previousSibling;
                        while (prev && prev.nodeType === 3 && !normalizeGuideText(prev.textContent)) {
                            prev = prev.previousSibling;
                        }
                        if (prev && prev.nodeType === 1 && prev.classList && prev.classList.contains('guide_pupop_size_image_text_gap')) {
                            br.parentNode.removeChild(br);
                            return;
                        }
                        var groupGap = document.createElement('span');
                        groupGap.className = 'guide_pupop_size_image_text_gap';
                        groupGap.setAttribute('aria-hidden', 'true');
                        br.parentNode.replaceChild(groupGap, br);
                    }
                });
            }
            wrapMeasurementTitleLines(root);
            root.setAttribute('data-guide-spaced', '3');
        });
    };

    function measureGuideTabNeedsWrap(tab) {
        var cs = window.getComputedStyle(tab);
        var probe = document.createElement('span');
        probe.textContent = (tab.textContent || '').replace(/\s+/g, ' ').trim();
        probe.style.cssText = [
            'position:absolute',
            'visibility:hidden',
            'pointer-events:none',
            'white-space:nowrap',
            'left:-9999px',
            'top:0',
            'font-size:' + cs.fontSize,
            'font-family:' + cs.fontFamily,
            'font-weight:' + cs.fontWeight,
            'font-style:' + cs.fontStyle,
            'letter-spacing:' + cs.letterSpacing,
            'text-transform:' + cs.textTransform,
            'padding:0',
            'margin:0',
            'border:0'
        ].join(';');
        document.body.appendChild(probe);
        var textWidth = probe.offsetWidth;
        document.body.removeChild(probe);
        var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
        var available = tab.clientWidth - pad;
        return textWidth > available + 1;
    }

    window.updateGuideFitHeaderWrap = function updateGuideFitHeaderWrap() {
        var boxes = document.querySelectorAll('.guide_pupop_fit_details_cm, .guide_pupop_fit_details_in');
        boxes.forEach(function (box) {
            var table = box.querySelector('table');
            if (!table || table.offsetWidth === 0) return;
            var firstRow = table.querySelector('tr');
            if (!firstRow) return;
            var cells = Array.prototype.slice.call(firstRow.children, 1);
            if (!cells.length) return;
            var needWrap = false;
            cells.forEach(function (cell) {
                if (!cell.dataset.guideFitHeaderOriginal) {
                    cell.dataset.guideFitHeaderOriginal = cell.innerHTML;
                }
                if (measureGuideTabNeedsWrap(cell)) {
                    needWrap = true;
                }
            });
            cells.forEach(function (cell) {
                var text = (cell.textContent || '').replace(/\s+/g, ' ').trim();
                var match = text.match(/^([^\s-]+)-([^\s-]+)$/);
                if (needWrap && match) {
                    cell.innerHTML = match[1] + '-<br>' + match[2];
                } else {
                    cell.innerHTML = cell.dataset.guideFitHeaderOriginal;
                }
            });
        });
    };

    function syncGuideTabCount(tabRow) {
        if (!tabRow) return [];
        var visibleTabs = Array.prototype.filter.call(
            tabRow.querySelectorAll('.product-tabs-tab'),
            function (tab) {
                return !tab.hidden;
            }
        );
        tabRow.classList.toggle('guide_pupop_tabs_one', visibleTabs.length === 1);
        tabRow.classList.toggle('guide_pupop_tabs_two', visibleTabs.length === 2);
        return visibleTabs;
    }

    function resolveGuideForMainInfo(infoRoot) {
        var info = (
            infoRoot &&
            infoRoot.classList &&
            infoRoot.classList.contains('product-info--pdp')
        ) ? infoRoot : document.querySelector('.product-info--pdp');
        var owner = info && info.closest ? info.closest('product-rerender') : null;
        var guide = owner ? owner.querySelector('.guide-pupop') : null;
        if (!guide && !infoRoot) {
            guide = document.querySelector('.guide-pupop');
        }
        return { info: info, guide: guide };
    }

    function activateScopedGuideTab(guide, targetTab, animate) {
        if (!guide || !targetTab || targetTab.hidden) return null;
        var tabRow = guide.querySelector('.guide_pupop_tabs');
        if (!tabRow || targetTab.parentElement !== tabRow) return null;
        var targetName = targetTab.getAttribute('data-name');
        tabRow.querySelectorAll('.product-tabs-tab').forEach(function (tab) {
            tab.classList.toggle('active', tab === targetTab);
        });
        var contents = guide.querySelectorAll('.guide_pupop_content');
        var targetContent = null;
        contents.forEach(function (content) {
            var isTarget = content.classList.contains('guide_pupop_content-' + targetName);
            content.classList.toggle('active', isTarget);
            if (isTarget) targetContent = content;
        });
        if (window.jQuery) {
            window.jQuery(contents).hide();
            if (targetContent) {
                if (animate) {
                    window.jQuery(targetContent).show(300);
                } else {
                    window.jQuery(targetContent).show();
                }
            }
        } else {
            contents.forEach(function (content) {
                content.style.display = content === targetContent ? '' : 'none';
            });
        }
        if (typeof window.updateGuideTabIndicatorLine === 'function') {
            window.updateGuideTabIndicatorLine(targetTab, animate === true, tabRow);
        }
        return targetTab;
    }

    function resolveGuideTriggerContext(trigger) {
        if (!trigger || !trigger.closest) return null;
        var owner = trigger.closest('product-rerender');
        if (!owner) return null;
        var info = owner.querySelector('.product-info--pdp');
        var guide = owner.querySelector('.guide-pupop');
        var guideBox = guide && guide.closest
            ? guide.closest('.guide-pupop-box')
            : owner.querySelector('.guide-pupop-box');
        var tabRow = guide ? guide.querySelector('.guide_pupop_tabs') : null;
        if (!info || !guide || !guideBox || !tabRow) return null;
        return {
            owner: owner,
            info: info,
            guide: guide,
            guideBox: guideBox,
            tabRow: tabRow
        };
    }

    function handleScopedGuideTabClick(tab) {
        if (!tab) return false;
        var tabRow = tab.parentElement;
        var formName = tab.getAttribute('data-form_name') ||
            (tabRow ? tabRow.getAttribute('data-form_name') : '');
        if (formName !== 'guide_tabs') return false;
        var guide = tab.closest ? tab.closest('.guide-pupop') : null;
        if (!guide || !activateScopedGuideTab(guide, tab, true)) return true;
        if (window.gsap && typeof window.gsap.to === 'function') {
            window.gsap.to(tabRow, {
                duration: 1,
                scrollTo: {
                    x: tab,
                    offsetX: 20
                },
                ease: 'power2.out'
            });
        }
        return true;
    }

    function openScopedGuideFromTrigger(trigger) {
        var context = resolveGuideTriggerContext(trigger);
        if (!context) return null;
        if (typeof window.syncGuideSizeConversion === 'function') {
            window.syncGuideSizeConversion(undefined, context.info);
        }
        if (typeof window.lockGuidePupopScroll === 'function') {
            window.lockGuidePupopScroll();
        }
        $(context.guideBox).stop(true, true).fadeIn(300);
        setTimeout(function () {
            if (window.formatGuideSizeImageText) window.formatGuideSizeImageText();
            if (window.updateGuideFitAxisLabels) window.updateGuideFitAxisLabels();
            if (window.updateGuideTabsSpacing) {
                window.updateGuideTabsSpacing(context.tabRow);
            }
        }, 50);
        return context;
    }

    function syncAllGuideSizeConversions() {
        if (typeof window.syncGuideSizeConversion !== 'function') return;
        document.querySelectorAll('.product-info--pdp').forEach(function (info) {
            window.syncGuideSizeConversion(undefined, info);
        });
    }

    window.openScopedGuideFromTrigger = openScopedGuideFromTrigger;
    window.syncAllGuideSizeConversions = syncAllGuideSizeConversions;

    function syncGuideSizeConversion(nextSku, infoRoot) {
        var guideContext = resolveGuideForMainInfo(infoRoot);
        var info = guideContext.info;
        var guide = guideContext.guide;
        if (!info || !guide) return;

        var sku;
        if (typeof nextSku === 'string') {
            sku = nextSku;
            guide.setAttribute('data-guide-current-sku', sku);
        } else if (guide.hasAttribute('data-guide-current-sku')) {
            sku = guide.getAttribute('data-guide-current-sku') || '';
        } else {
            sku = guide.getAttribute('data-guide-initial-sku') || '';
            guide.setAttribute('data-guide-current-sku', sku);
        }

        var heightSelector = info.querySelector('[data-pdp-height]');
        var hasMultipleSets = Boolean(heightSelector && !heightSelector.hasAttribute('hidden'));
        var fitStatePending = hasMultipleSets && !info.hasAttribute('data-pdp-size-fit');
        var fit = info.getAttribute('data-pdp-size-fit') || '';
        var tableKey = (
            window.SizeGuideRouting &&
            typeof window.SizeGuideRouting.resolveTableKey === 'function'
        ) ? window.SizeGuideRouting.resolveTableKey(sku, hasMultipleSets, fit) : null;

        guide.querySelectorAll('[data-guide-table-key]').forEach(function (group) {
            group.hidden = !tableKey || group.getAttribute('data-guide-table-key') !== tableKey;
        });

        var tabRow = guide.querySelector('.guide_pupop_tabs');
        var conversionTab = guide.querySelector('.guide_pupop_tabs [data-name="gui_pupop_tab1"]');
        var measurementsTab = guide.querySelector('.guide_pupop_tabs [data-name="gui_pupop_tab2"]');
        var conversionContent = guide.querySelector('.guide_pupop_content-gui_pupop_tab1');
        var hasActiveTab = Boolean(tabRow && tabRow.querySelector('.product-tabs-tab.active'));
        var conversionWasActive = Boolean(
            (conversionTab && conversionTab.classList.contains('active')) ||
            (!hasActiveTab && conversionContent && conversionContent.classList.contains('active'))
        );

        if (conversionTab) conversionTab.hidden = !tableKey;
        if (conversionContent) conversionContent.hidden = !tableKey;

        if (!tableKey && !fitStatePending && conversionWasActive) {
            var fallbackTab = measurementsTab && !measurementsTab.hidden
                ? measurementsTab
                : syncGuideTabCount(tabRow)[0];
            if (fallbackTab) {
                activateScopedGuideTab(guide, fallbackTab, false);
            } else if (typeof window.updateGuideTabIndicatorLine === 'function') {
                window.updateGuideTabIndicatorLine(null, false, tabRow);
            }
        } else if (
            tableKey &&
            !hasActiveTab &&
            conversionContent &&
            conversionContent.classList.contains('active') &&
            conversionTab
        ) {
            conversionTab.classList.add('active');
        }

        syncGuideTabCount(tabRow);
        if (typeof window.updateGuideTabsSpacing === 'function') {
            window.updateGuideTabsSpacing(tabRow);
        }
        if (typeof window.updateGuideTabIndicatorLine === 'function') {
            window.updateGuideTabIndicatorLine(null, false, tabRow);
        }
    }

    window.syncGuideSizeConversion = syncGuideSizeConversion;

    window.updateGuideTabsSpacing = function updateGuideTabsSpacing(tabRow) {
        var rows = tabRow
            ? [tabRow]
            : document.querySelectorAll('.guide-pupop-content .guide_pupop_tabs');
        rows.forEach(function (row) {
            var box = row.closest('.product-tabs-box');
            row.classList.remove('guide_pupop_tabs--compact');
            if (box) {
                box.classList.remove('guide_pupop_tabs_box--compact');
            }
            void row.offsetWidth;
            var tabs = syncGuideTabCount(row);
            var need = false;
            tabs.forEach(function (tab) {
                if (measureGuideTabNeedsWrap(tab)) {
                    need = true;
                }
            });
            if (need) {
                row.classList.add('guide_pupop_tabs--compact');
                if (box) {
                    box.classList.add('guide_pupop_tabs_box--compact');
                }
            }
        });
        rows.forEach(function (row) {
            window.updateGuideTabIndicatorLine(null, false, row);
        });
        window.updateGuideFitHeaderWrap();
    };

    window.updateGuideTabIndicatorLine = function updateGuideTabIndicatorLine(activeTab, animate, tabRow) {
        var tab = activeTab;
        var row = tabRow || (tab && tab.parentElement
            ? tab.parentElement
            : document.querySelector('.guide-pupop-content .guide_pupop_tabs'));
        if (!row) return;
        var visibleTabs = tab && tab.parentElement && !tabRow
            ? syncGuideTabCount(tab.parentElement)
            : syncGuideTabCount(row);
        if (!tab || tab.hidden || visibleTabs.indexOf(tab) < 0) {
            tab = visibleTabs.find(function (item) {
                return item.classList.contains('active');
            }) || visibleTabs[0];
        }
        var box = row.closest('.product-tabs-box');
        var line = box ? box.querySelector('.product-tabs-linebox-line') : null;
        if (!line) return;
        if (!visibleTabs.length || !tab) {
            line.hidden = true;
            line.style.left = '0%';
            line.style.width = '0%';
            return;
        }
        line.hidden = false;
        var track = line.parentElement;
        if (!track) return;
        var count = visibleTabs.length;
        var idx = visibleTabs.indexOf(tab);
        if (idx < 0) idx = 0;
        if (window.innerWidth > 768 || count <= 2) {
            var step = count === 1 ? 100 : count === 2 ? 50 : 33.33;
            if (animate !== false && window.gsap) {
                gsap.to(line, {
                    left: idx * step + '%',
                    width: step + '%',
                    duration: 0.5
                });
            } else {
                line.style.left = idx * step + '%';
                line.style.width = step + '%';
            }
            return;
        }
        var trackRect = track.getBoundingClientRect();
        var tabRect = tab.getBoundingClientRect();
        var left = tabRect.left - trackRect.left;
        var width = tabRect.width;
        if (animate !== false && window.gsap) {
            gsap.to(line, {
                left: left,
                width: width,
                duration: 0.5
            });
        } else {
            line.style.left = left + 'px';
            line.style.width = width + 'px';
        }
    };

    var guideTabsResizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(guideTabsResizeTimer);
        guideTabsResizeTimer = setTimeout(function () {
            window.updateGuideTabsSpacing();
        }, 100);
    });

    var guideTableHoverSelector = '.guide_pupop_conversion_table table, .guide_pupop_fit_details_cm table, .guide_pupop_fit_details_in table';
    var guideTableCellSelector = '.guide_pupop_conversion_table th, .guide_pupop_conversion_table td, .guide_pupop_fit_details_cm th, .guide_pupop_fit_details_cm td, .guide_pupop_fit_details_in th, .guide_pupop_fit_details_in td';

    function buildGuideTableMatrix(table) {
      var matrix = [];
      var rowCount = table.rows.length;
      var r;
      for (r = 0; r < rowCount; r++) {
        matrix[r] = [];
      }
      for (r = 0; r < rowCount; r++) {
        var col = 0;
        var cells = table.rows[r].cells;
        for (var i = 0; i < cells.length; i++) {
          var cell = cells[i];
          while (matrix[r][col]) {
            col++;
          }
          var rowSpan = cell.rowSpan || 1;
          var colSpan = cell.colSpan || 1;
          var ri;
          var ci;
          for (ri = 0; ri < rowSpan; ri++) {
            if (!matrix[r + ri]) {
              matrix[r + ri] = [];
            }
            for (ci = 0; ci < colSpan; ci++) {
              matrix[r + ri][col + ci] = cell;
            }
          }
          col += colSpan;
        }
      }
      return matrix;
    }

    function clearGuideTableHighlight(table) {
      table.querySelectorAll('.guide-table-hl').forEach(function(cell) {
        cell.classList.remove('guide-table-hl');
      });
    }

    function getGuideTableCellPosition(matrix, targetCell) {
      for (var r = 0; r < matrix.length; r++) {
        for (var c = 0; c < matrix[r].length; c++) {
          if (matrix[r][c] === targetCell) {
            return { row: r, col: c };
          }
        }
      }
      return null;
    }

    function highlightGuideTableCross(table, targetCell) {
      clearGuideTableHighlight(table);
      var matrix = buildGuideTableMatrix(table);
      var pos = getGuideTableCellPosition(matrix, targetCell);
      if (!pos) return;
      var highlighted = new Set();
      function shouldSkipTitleCell(cell) {
        return cell && cell.colSpan > 1 && cell.parentElement && cell.parentElement.parentElement && cell.parentElement.parentElement.tagName === 'THEAD';
      }
      var c;
      for (c = 0; c < matrix[pos.row].length; c++) {
        var rowCell = matrix[pos.row][c];
        if (rowCell && !highlighted.has(rowCell) && !shouldSkipTitleCell(rowCell)) {
          rowCell.classList.add('guide-table-hl');
          highlighted.add(rowCell);
        }
      }
      var r;
      for (r = 0; r < matrix.length; r++) {
        var colCell = matrix[r][pos.col];
        if (colCell && !highlighted.has(colCell) && !shouldSkipTitleCell(colCell)) {
          colCell.classList.add('guide-table-hl');
          highlighted.add(colCell);
        }
      }
    }

    let currentUnit = 'cm';

    function getSizeGuideSkipRows(row) {
      const table = row.closest('table');
      const skipRows = table ? table.getAttribute('data-size-guide-skip-unit-rows') : '';
      return skipRows ? skipRows.split(',').map((item) => item.trim().toUpperCase()).filter(Boolean) : [];
    }

    function getSizeGuideRowName(row) {
      const firstCell = row.querySelector('td');
      return firstCell ? firstCell.innerText.split('(')[0].trim() : '';
    }

    function shouldSkipSizeGuideUnitRow(row) {
      const rowName = getSizeGuideRowName(row).toUpperCase();
      return getSizeGuideSkipRows(row).includes(rowName);
    }

    function shouldUseSizeGuideDecimalConversion(row) {
      const table = row.closest('table');
      const decimalConversion = table ? table.getAttribute('data-size-guide-decimal-conversion') : '';
      return decimalConversion === '1' || decimalConversion === 'true';
    }

    function formatSizeGuideConvertedValue(value, row) {
      return shouldUseSizeGuideDecimalConversion(row) ? value.toFixed(1) : Math.round(value.toFixed(2));
    }

    function getSizeGuideOriginalCellText(cell) {
      if (!cell.dataset.sizeGuideOriginalValue) {
        cell.dataset.sizeGuideOriginalValue = cell.innerText.trim();
      }
      return cell.dataset.sizeGuideOriginalValue;
    }

    function toggleUnits() {
      const rows = document.querySelectorAll('#sizeTableBody tr');

      rows.forEach((row,index) => {
         if (index === rows.length - 1) return;
        const cells = row.querySelectorAll('td');
        const skipUnitRow = shouldSkipSizeGuideUnitRow(row);

        const firstCell = row.querySelector('td');
        if (firstCell && !skipUnitRow) {
          const text = firstCell.innerText.split('(')[0].trim();
          if (firstCell.closest('.guide_pupop_details_cm')) {
            firstCell.innerText = text;
          } else {
            firstCell.innerText = `${text} (${currentUnit})`;
          }
        }

        if (skipUnitRow) return;

        cells.forEach((cell,idx) => {
          const text = cell.innerText.trim();

          if (text && !isNaN(text) && text !== '/') {
            let value = parseFloat(text);
            if (shouldUseSizeGuideDecimalConversion(row)) {
              const originalText = getSizeGuideOriginalCellText(cell);
              value = parseFloat(originalText);
              cell.innerText = currentUnit === 'cm' ? formatSizeGuideConvertedValue(value * 0.393701, row) : originalText;
              return;
            }

            if (currentUnit === 'cm') {
              const inchValue = formatSizeGuideConvertedValue(value * 0.393701, row);
              cell.innerText = inchValue;
            }
            else {
              const cmValue = formatSizeGuideConvertedValue(value / 0.393701, row);
              cell.innerText = cmValue;
            }
          }
        });
      });

      currentUnit = currentUnit === 'cm' ? 'in' : 'cm';

      updateUnitInHeader();
    }

    function updateUnitInHeader() {
      const headers = document.querySelectorAll('#sizeTableBody tr');
      
      headers.forEach((header,index) => {
        if (index === headers.length - 1) return;
        let td = header.querySelector('td');
        if (td && !shouldSkipSizeGuideUnitRow(header)) {
          const text = td.innerText.split('(')[0].trim();
          if (td.closest('.guide_pupop_details_cm')) {
            td.innerText = text;
          } else {
            td.innerText = `${text} (${currentUnit})`;
          }
        }
      });
    }

    function hydrateAddToCartSizebox() {
        var source = document.getElementById('add-to-card-sizebox-source');
        var dest = document.getElementById('add-to-card-sizebox');
        if (!source || !dest) return;
        dest.innerHTML = source.innerHTML;
        $('.notify_me_text').off('click.productInfoNotify').on('click.productInfoNotify', function () {
            $('.add-to-card-pupop').fadeOut(400);
            $('.notify-me-pupopbox').fadeIn(300);
            $('#notify_form_product_title').val($(this).attr('data-title'));
            $('#notify_form_product_size').val($(this).attr('data-name'));
        });
        $('.notify-me-pupop-btn').off('click.productInfoNotify').on('click.productInfoNotify', function () {
            $('.notify-me-pupopbox').fadeOut(400);
            $('.add-to-card-pupop').fadeIn(300);
        });
        $('.notify-me-submitbox button[type="submit"]').off('click.productInfoNotify').on('click.productInfoNotify', function () {
            localStorage.setItem('notify_succsess', true);
        });
        var priceHtml = $('.product-info__block-item[data-block-type="price"] .product-price-item-hidden').html();
        if (priceHtml) {
            $('#add-to-cart-pupop-pricebox').html(priceHtml);
        }
    }

    function applyAddToCartSizeAvailability() {
        var source = document.getElementById('add-to-card-sizebox-source');
        if (!source) return;
        var isAvailable = source.getAttribute('data-size-available') === 'true';
        var isPreOrder = source.getAttribute('data-size-pre-order') === 'true';
        var preOrderLabel = source.getAttribute('data-pre-order-label') || 'Pre-order';
        if (isAvailable) {
            $('#add-to-card-pupop-btn-card').text(isPreOrder ? preOrderLabel : 'ADD TO CART').attr('disabled', false);
        } else {
            $('#add-to-card-pupop-btn-card').text('SOLD OUT').attr('disabled', true);
        }
    }

    window.initProductInfo = function initProductInfo() {
        currentUnit = 'cm';
        hydrateAddToCartSizebox();
        var $atcPupop = $('.add-to-card-pupop');
        if ($atcPupop.length && !$atcPupop.hasClass('active') && $atcPupop.css('display') === 'none') {
            $atcPupop.css('display', '');
        }

        $('.product-tabs-box .product-tabs .product-tabs-tab').off('click.productInfo').on('click.productInfo',function(){
            if (handleScopedGuideTabClick(this)) return;
            var idx = $(this).index();
            var name = $(this).attr('data-name');
            var form_name =$(this).attr('data-form_name')
            var custom_class = $(this).attr('data-line-class');
            var data_content = $(this).attr('data-content');
            var max_length = $(this).attr('max-length');
            var data_form_name = $(this).parent().attr('data-form_name');
            var setp = 20;
           if(data_form_name == 'product_tabs'){
               if($('.'+data_content)){
                    var left_value = idx==0? '0%': idx==1? '22%': idx==2? '42%': idx==3? '62%': idx==4? '82%': '0%';
                    gsap.to('.'+custom_class+' .product-tabs-linebox-line',{
                        left: left_value,
                        duration: 0.5
                    });
                    $('.'+data_content).hide();
                  
                    $('.'+data_content+'-'+name).show(300);
                }

            }else{
               if($('.'+data_content)){
                  gsap.to('.'+custom_class+' .product-tabs-linebox-line',{
                      left: idx*setp+'%',
                      duration: 0.5
                  });
                  $('.'+data_content).hide();
                
                  $('.'+data_content+'-'+name).show(300);
              }

           }
        })

        if (typeof window.syncAllGuideSizeConversions === 'function') {
            window.syncAllGuideSizeConversions();
        }

        $('.product-tabs-content-guide-btn').off('click.productInfo').on('click.productInfo',function(){
            openScopedGuideFromTrigger(this);
        })

        $('.pdp-fabric-images .fabric_image, .product-tabs-box .fabric_image').off('click.productInfo').on('click.productInfo',function(){
            var index = $(this).closest('.fabric_image_list_item, .pdp-feature-icon').index();
            $('.fabric_image_list_item_imgbox').hide();
            $('.fabric-pupop-desc-item').hide();
            $('.fabric_image_list_item_imgbox').eq(index).fadeIn(300);
            $('.fabric-pupop-desc-item').eq(index).fadeIn(300);
             $('.fabric-pupop-box').fadeIn(300);
        })

        $('#select_size_button').off('click.productInfo').on('click.productInfo',function(){
            var $info = $('.product-info--pdp');
            if (!$info.length) {
                gsap.to('.add-to-card-pupop-content',{
                    height: 'auto',
                    duration: 0.5,
                    ease: 'power2.inOut'
                });
                $('.add-to-card-pupop').addClass('active')
                gsap.to('.add-to-card-pupop-btn',{
                    background: '#545454',
                     duration: 0.5,
                })
                return;
            }
            var $select = $info.find('.pdp-select--size');
            if ($info.hasClass('pdp-size-chosen') || !$select.find('.pdp-select-menu__item').length) {
                var $submit = $('.product buy-buttons button[type="submit"]');
                if ($submit.attr('disabled')) return;
                $submit.trigger('click');
                return;
            }
            setTimeout(function () {
                $info.find('.pdp-select.is-open').not($select).removeClass('is-open').find('[data-pdp-select-toggle]').attr('aria-expanded', 'false');
                $select.addClass('is-open');
                $select.find('[data-pdp-select-toggle]').attr('aria-expanded', 'true');
                var node = $select.get(0);
                if (node) node.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }, 0);
        })

         $('#add-to-card-pupop-btn-card').off('click.productInfo').on('click.productInfo',function(){
            if(!$(this).attr('disabled')){
                 $('.product buy-buttons button[type="submit"').click();
            }
         })
        
         $('.guide_pupop_merged_switch').off('click.productInfo').on('click.productInfo',function(e){
            e.stopPropagation();
            $(this).closest('.guide_pupop_merged_reference').toggleClass('guide_pupop_merged_show_in');
         })

         $('.guide_pupop_top_cm_in_switch').off('click.productInfo','.guide_pupop_body_measurements_switch_item').on('click.productInfo','.guide_pupop_body_measurements_switch_item',function(e){
            e.stopPropagation();
            const nextUnit = $(this).attr('data-unit');
            if (!nextUnit || nextUnit === currentUnit) return;
            toggleUnits();
            const $switch = $(this).closest('.guide_pupop_top_cm_in_switch');
            $switch.attr('data-active', currentUnit);
            $switch.find('.guide_pupop_body_measurements_switch_item').removeClass('is-active');
            $switch.find('[data-unit="' + currentUnit + '"]').addClass('is-active');
          })

          $('.guide_pupop_fit_switch').off('click.productInfo','.guide_pupop_body_measurements_switch_item').on('click.productInfo','.guide_pupop_body_measurements_switch_item',function(e){
            e.stopPropagation();
            const nextUnit = $(this).attr('data-unit');
            const $switch = $(this).closest('.guide_pupop_fit_switch');
            if (!nextUnit || $switch.attr('data-active') === nextUnit) return;
            $switch.attr('data-active', nextUnit);
            $switch.find('.guide_pupop_body_measurements_switch_item').removeClass('is-active');
            $(this).addClass('is-active');
            const $tab = $(this).closest('.guide_pupop_content-gui_pupop_tab3');
            if (nextUnit === 'in') {
              $tab.addClass('guide_pupop_fit_show_in');
            } else {
              $tab.removeClass('guide_pupop_fit_show_in');
            }
            if (typeof window.updateGuideFitAxisLabels === 'function') {
              window.updateGuideFitAxisLabels($tab[0]);
            }
            if (typeof window.updateGuideFitHeaderWrap === 'function') {
              window.updateGuideFitHeaderWrap();
            }
          })

          $('.guide_pupop_body_measurements_table .guide_pupop_body_measurements_switch').off('click.productInfo','.guide_pupop_body_measurements_switch_item').on('click.productInfo','.guide_pupop_body_measurements_switch_item',function(e){
            e.stopPropagation();
            const tableBox = $(this).closest('.guide_pupop_body_measurements_table');
            if (!tableBox.length) return;
            const currentBodyMeasurementsUnit = tableBox.attr('data-guide-body-measurements-unit') || 'cm';
            const nextBodyMeasurementsUnit = $(this).attr('data-unit');
            if (!nextBodyMeasurementsUnit || nextBodyMeasurementsUnit === currentBodyMeasurementsUnit) return;

            tableBox.attr('data-guide-body-measurements-unit', nextBodyMeasurementsUnit);
            tableBox.find('.guide_pupop_body_measurements_switch').attr('data-active', nextBodyMeasurementsUnit);
            tableBox.find('.guide_pupop_body_measurements_switch_item').removeClass('is-active');
            $(this).addClass('is-active');
            tableBox.find('tbody tr').each(function(){
              const cells = Array.from(this.querySelectorAll('td'));
              if (!cells.length) return;

              const firstCellText = cells[0].innerText.trim();
              const measurementStartIndex = firstCellText && !isNaN(firstCellText) ? 1 : 2;

              cells.slice(measurementStartIndex).forEach((cell) => {
                if (!cell.dataset.guideBodyMeasurementsCm) {
                  cell.dataset.guideBodyMeasurementsCm = cell.innerText.trim();
                }

                const cmValue = parseFloat(cell.dataset.guideBodyMeasurementsCm);
                if (isNaN(cmValue)) return;

                cell.innerText = nextBodyMeasurementsUnit === 'in' ? Math.round(cmValue * 0.393701) : cell.dataset.guideBodyMeasurementsCm;
              });
            });
          })

        $(document).off('mouseover.productInfo', guideTableCellSelector).on('mouseover.productInfo', guideTableCellSelector, function() {
          var table = this.closest('table');
          if (!table) return;
          highlightGuideTableCross(table, this);
        });

        $(document).off('mouseleave.productInfo', guideTableHoverSelector).on('mouseleave.productInfo', guideTableHoverSelector, function() {
          clearGuideTableHighlight(this);
        });

        $('#add-to-card-pupop-btn-card').text($('.product buy-buttons button[type="submit"] button-content').attr('up-text'));
        $('#add-to-card-pupop-btn-card').attr("disabled",$('.product buy-buttons button[type="submit"]').attr('disabled'))
        var inlineAtcPrice = document.querySelector('[data-pdp-inline-atc-price]');
        var popupPrice = document.getElementById('add-to-cart-pupop-pricebox');
        if (inlineAtcPrice && popupPrice && popupPrice.textContent.trim()) {
            inlineAtcPrice.textContent = popupPrice.textContent.replace(/\s+/g, ' ').replace(/([A-Za-z])(\$)/g, '$1 $2').trim();
        }
        applyAddToCartSizeAvailability();
        
        console.log(localStorage.getItem('notify_succsess'))
       if(localStorage.getItem('notify_succsess')){
            $('.add-to-card-pupop').fadeOut(300);
            $('.notify-me-pupopbox').fadeIn(400);
            localStorage.removeItem('notify_succsess');
        }

        $('.indicator-box .indicator-box-item').off('click.productInfo').on('click.productInfo',function(){
           let  indicator_index = $(this).index();
            if(window.innerWidth > 1000){
                    gsap.to(window, {
                        duration: 1,
                        scrollTo: {
                            y: document.querySelectorAll('product-gallery scroll-carousel .product-gallery__media:not([hidden])')[indicator_index],
                            offsetY: 20
                        },
                        ease: "power2.out"
                    });
            }
        })

        window.formatGuideSizeImageText();
        window.updateGuideFitAxisLabels();
        window.updateGuideTabsSpacing();
        window.updateGuideTabIndicatorLine(null, false);
        $(document).off('click.productInfo', '.product-tabs-box .guide_pupop_tabs .product-tabs-tab').on('click.productInfo', '.product-tabs-box .guide_pupop_tabs .product-tabs-tab', function () {
            setTimeout(function () {
                window.formatGuideSizeImageText();
                window.updateGuideFitAxisLabels();
            }, 50);
            setTimeout(function () {
                window.updateGuideFitHeaderWrap();
            }, 350);
        });
    };

    $(document).ready(function() {
        window.initProductInfo();
    });

    document.addEventListener('variant:change', function () {
        hydrateAddToCartSizebox();
        applyAddToCartSizeAvailability();
    });

})();

(function () {
    if (typeof jQuery === 'undefined') return;
    var $ = jQuery;

    function pdpTabsBreakSpacing() {
        document.querySelectorAll('.product-tabs-box.pdp-tabs-box .pdp-tab-panel br').forEach(function (br) {
            if (!br.isConnected) return;
            var next = br.nextSibling;
            while (next && next.nodeType === 3 && !next.textContent.trim()) next = next.nextSibling;
            var span = document.createElement('span');
            span.className = 'pdp-tab-break';
            if (next && next.nodeName === 'BR') {
                span.classList.add('pdp-tab-break--blank');
                next.remove();
            }
            br.replaceWith(span);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', pdpTabsBreakSpacing);
    } else {
        pdpTabsBreakSpacing();
    }

    function pdpTabsMoveLine(tab) {
        var $box = $(tab).closest('.pdp-tabs-box');
        var line = $box.find('.pdp-tabs-track__line').get(0);
        var track = $box.find('.pdp-tabs-track').get(0);
        if (!line || !track) return;
        var tabRect = tab.getBoundingClientRect();
        var trackRect = track.getBoundingClientRect();
        line.style.left = Math.max(0, Math.round(tabRect.left - trackRect.left)) + 'px';
        line.style.width = Math.max(0, Math.round(tabRect.width)) + 'px';
    }

    function pdpTabsMoveActiveLine() {
        document.querySelectorAll('.pdp-tabs-nav__tab.active').forEach(pdpTabsMoveLine);
    }

    $(document).on('click.pdpTabs', '.pdp-tabs-nav__tab', function () {
        var $tab = $(this);
        var name = $tab.attr('data-pdp-tab');
        var $box = $tab.closest('.pdp-tabs-box');
        $box.find('.pdp-tabs-nav__tab').removeClass('active');
        $tab.addClass('active');
        $box.find('.pdp-tab-panel').removeClass('active');
        $box.find('.product-tabs-content-' + name).addClass('active');
        pdpTabsMoveLine(this);
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', pdpTabsMoveActiveLine);
    } else {
        pdpTabsMoveActiveLine();
    }
    window.addEventListener('resize', pdpTabsMoveActiveLine);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(pdpTabsMoveActiveLine);
    }

    $(document).on('click.pdpAcc', '.pdp-acc-head', function () {
        var $item = $(this).closest('.pdp-acc-item');
        var open = !$item.hasClass('open');
        if (window.innerWidth < 1000) {
            $item.siblings('.pdp-acc-item.open').removeClass('open');
        }
        $item.toggleClass('open', open);
    });

    $(document).on('click.pdpInlineAtc', '[data-pdp-inline-atc]', function () {
        $('#select_size_button').trigger('click');
    });

    $(document).on('click.pdpSizeChart', '.pdp-size-chart-link, .pdp-fit-size-guide', function () {
        if (typeof window.openScopedGuideFromTrigger === 'function') {
            window.openScopedGuideFromTrigger(this);
        }
    });

    function pdpSelectClose(except) {
        $('.pdp-select.is-open').each(function () {
            if (this === except) return;
            $(this).removeClass('is-open').find('[data-pdp-select-toggle]').attr('aria-expanded', 'false');
        });
    }

    function pdpClearSizeChoice($box, $current) {
        $box.removeClass('pdp-size-chosen');
        $current.removeClass('is-current');
        var inputId = $current.find('label').attr('for');
        var input = inputId ? document.getElementById(inputId) : null;
        if (!input) return;
        input.checked = false;
        var form = input.form || document.getElementById(input.getAttribute('form'));
        if (!form) return;
        var idInput = form.querySelector('input[name="id"]:not([disabled])');
        if (idInput) idInput.value = '';
    }

    function pdpApplySizeFit($scope) {
        var $infos = ($scope && $scope.length) ? $scope : $('.product-info--pdp');
        $infos.each(function () {
            var $box = $(this);
            var $rows = $box.find('.pdp-select--size .pdp-select-menu__item');
            var fitMap = {};
            $rows.each(function () {
                var rowFit = ($(this).attr('data-size-fit') || '').toLowerCase();
                if (rowFit) fitMap[rowFit] = true;
            });
            var fitKeys = Object.keys(fitMap);
            var $height = $box.find('[data-pdp-height]');
            var $fabric = $box.find('.fabric-switcher').first();
            if ($fabric.length && $height.length) $height.insertBefore($fabric);
            if (fitKeys.length !== 2) {
                $height.attr('hidden', 'hidden');
                $rows.removeAttr('hidden');
                return;
            }
            $height.removeAttr('hidden');
            var fit = ($box.attr('data-pdp-size-fit') || '').toLowerCase();
            if (!fitMap[fit]) {
                var currentFit = ($rows.filter('.is-current').attr('data-size-fit') || '').toLowerCase();
                if ($box.hasClass('pdp-size-chosen') && fitMap[currentFit]) {
                    fit = currentFit;
                } else if (fitMap.regular) {
                    fit = 'regular';
                } else {
                    fit = fitKeys[0];
                }
                $box.attr('data-pdp-size-fit', fit);
            }
            $height.find('.pdp-height__item').removeClass('is-active').attr('aria-pressed', 'false');
            $height.find('[data-size-fit="' + fit + '"]').addClass('is-active').attr('aria-pressed', 'true');
            $height.find('[data-pdp-height-copy]').text(fit === 'regular' ? 'Above' : 'Below');
            $rows.each(function () {
                if (($(this).attr('data-size-fit') || '').toLowerCase() === fit) $(this).removeAttr('hidden');
                else $(this).attr('hidden', 'hidden');
            });
            var $current = $rows.filter('.is-current');
            if ($box.hasClass('pdp-size-chosen') && $current.is('[hidden]')) {
                pdpClearSizeChoice($box, $current);
            }
        });
    }

    window.pdpApplySizeFit = pdpApplySizeFit;

    $(document).on('click.pdpHeight', '.pdp-height__item', function () {
        var $item = $(this);
        var $box = $item.closest('.product-info--pdp');
        var fit = ($item.attr('data-size-fit') || '').toLowerCase();
        $box.attr('data-pdp-size-fit', fit);
        $item.closest('.pdp-height').find('.pdp-height__item').removeClass('is-active').attr('aria-pressed', 'false');
        $item.addClass('is-active').attr('aria-pressed', 'true');
        pdpSelectClose();
        pdpApplySizeFit($box);
        if (typeof window.syncGuideSizeConversion === 'function') {
            window.syncGuideSizeConversion(undefined, $box[0]);
        }
    });

    $(document).on('click.pdpSelectToggle', '[data-pdp-select-toggle]', function () {
        var $select = $(this).closest('.pdp-select');
        var open = !$select.hasClass('is-open');
        pdpSelectClose($select.get(0));
        $select.toggleClass('is-open', open);
        $(this).attr('aria-expanded', open ? 'true' : 'false');
    });

    $(document).on('click.pdpSelectItem', '.pdp-select-menu__item', function (e) {
        if ($(e.target).closest('.pdp-select-menu__notify').length) return;
        if ($(this).closest('.pdp-select--size').length) {
            var $item = $(this);
            if ($item.hasClass('is-disabled')) {
                pdpSelectClose();
                return;
            }
            var $box = $item.closest('.product-info--pdp');
            var inputId = $item.find('.pdp-select-menu__label').attr('for');
            var input = inputId ? document.getElementById(inputId) : null;
            if (input && !input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            var labelText = $.trim($item.find('.pdp-select-menu__label').text());
            $box.addClass('pdp-size-chosen');
            if (labelText) {
                $box.find('.pdp-select--size .pdp-select-bar__label--value').text(labelText);
            }
            $item.addClass('is-current').siblings('.pdp-select-menu__item').removeClass('is-current');
        }
        pdpSelectClose();
    });

    $(document).on('click.pdpSelectNotify', '.pdp-select-menu__notify', function () {
        pdpSelectClose();
        $('.notify-me-pupopbox').fadeIn(300);
        $('#notify_form_product_title').val($(this).attr('data-title'));
        $('#notify_form_product_size').val($(this).attr('data-name'));
    });

    $(document).on('click.pdpSelectOutside', function (e) {
        if ($(e.target).closest('.pdp-select').length) return;
        pdpSelectClose();
    });

    $(document).on('keydown.pdpSelectEsc', function (e) {
        if (e.key === 'Escape') pdpSelectClose();
    });

    $(function () {
        if (/[?&]variant=/.test(window.location.search)) {
            $('.product-info--pdp').addClass('pdp-size-chosen');
        }
        pdpApplySizeFit();
        if (typeof window.syncAllGuideSizeConversions === 'function') {
            window.syncAllGuideSizeConversions();
        }
    });

    function getMainPdpInfoForVariantEvent(event) {
        var detail = event && event.detail;
        var formId = detail && detail.formId;
        var infos = document.querySelectorAll('.product-info--pdp');
        if (typeof formId === 'string' && formId) {
            for (var i = 0; i < infos.length; i++) {
                var picker = infos[i].querySelector('variant-picker[form-id]');
                if (picker && picker.getAttribute('form-id') === formId) {
                    return infos[i];
                }
            }
            return null;
        }
        if (event && event.target && event.target.closest) {
            return event.target.closest('.product-info--pdp');
        }
        return null;
    }

    function syncGuideVariantFromEvent(event) {
        var info = getMainPdpInfoForVariantEvent(event);
        if (!info) return;
        setTimeout(function () {
            pdpApplySizeFit($(info));
            var sku = (
                event.detail &&
                event.detail.variant &&
                typeof event.detail.variant.sku === 'string'
            ) ? event.detail.variant.sku : '';
            if (typeof window.syncGuideSizeConversion === 'function') {
                window.syncGuideSizeConversion(sku, info);
            }
        }, 0);
    }

    document.addEventListener('variant:change', syncGuideVariantFromEvent);
})();

(function () {
    var dragState = null;

    function pdpGalleryCells(carousel) {
        return Array.prototype.filter.call(carousel.children, function (cell) {
            return !cell.hasAttribute('hidden') && cell.classList.contains('product-gallery__media');
        });
    }

    function pdpGalleryAllCells(carousel) {
        return Array.prototype.filter.call(carousel.children, function (cell) {
            return cell.classList.contains('product-gallery__media');
        });
    }

    function pdpGalleryClearWidths(carousel) {
        var wrap = carousel.closest('.relative') || carousel.parentElement;
        wrap.style.width = '';
        wrap.style.maxWidth = '';
        carousel.style.width = '';
        carousel.style.maxWidth = '';
        var cells = pdpGalleryAllCells(carousel);
        for (var i = 0; i < cells.length; i++) {
            cells[i].style.flex = '';
            cells[i].style.width = '';
            cells[i].style.minWidth = '';
            cells[i].style.maxWidth = '';
        }
    }

    function pdpGallerySyncWidths(carousel) {
        var wrap = carousel.closest('.relative') || carousel.parentElement;
        var list = carousel.closest('.product-gallery__image-list') || wrap.parentElement;
        var host = carousel.closest('.product-gallery') || list;
        var raw = host.getBoundingClientRect().width;
        var w = Math.floor(raw);
        if (w <= 0) {
            pdpGalleryClearWidths(carousel);
            return 0;
        }
        var cells = pdpGalleryAllCells(carousel);
        if (window.innerWidth < 1000 && cells.length && parseFloat(cells[0].style.width) === w) {
            return w;
        }
        if (window.innerWidth < 1000) {
            wrap.style.width = '';
            wrap.style.maxWidth = '';
            carousel.style.width = '100%';
            carousel.style.maxWidth = '100%';
        } else {
            wrap.style.width = w + 'px';
            wrap.style.maxWidth = w + 'px';
            carousel.style.width = w + 'px';
            carousel.style.maxWidth = w + 'px';
        }
        for (var i = 0; i < cells.length; i++) {
            cells[i].style.flex = '0 0 ' + w + 'px';
            cells[i].style.width = w + 'px';
            cells[i].style.minWidth = w + 'px';
            cells[i].style.maxWidth = w + 'px';
            var media = cells[i].querySelector('img, video');
            if (!media) continue;
            if (window.innerWidth < 1000) {
                var aw = parseInt(media.getAttribute('width'), 10);
                var ah = parseInt(media.getAttribute('height'), 10);
                if (aw > 0 && ah > 0) media.style.aspectRatio = aw + ' / ' + ah;
            } else {
                media.style.aspectRatio = '';
            }
        }
        return w;
    }

    function pdpGallerySnapLeft(carousel, index) {
        var cells = pdpGalleryCells(carousel);
        if (!cells.length) return 0;
        var i = Math.min(Math.max(index, 0), cells.length - 1);
        var cell = cells[i];
        var maxLeft = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        return Math.min(Math.max(cell.offsetLeft, 0), maxLeft);
    }

    function pdpGalleryClosestIndex(carousel, scrollLeft) {
        var cells = pdpGalleryCells(carousel);
        if (!cells.length) return 0;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < cells.length; i++) {
            var dist = Math.abs(cells[i].offsetLeft - scrollLeft);
            if (dist < bestDist) {
                bestDist = dist;
                best = i;
            }
        }
        return best;
    }

    function pdpGalleryResync(carousel, snapToFirst) {
        var idx = snapToFirst ? 0 : pdpGalleryClosestIndex(carousel, carousel.scrollLeft);
        var w = pdpGallerySyncWidths(carousel);
        if (w > 0 && carousel.dataset.pdpTouching !== '1') {
            carousel.scrollLeft = pdpGallerySnapLeft(carousel, idx);
        }
    }

    function pdpGallerySyncArrows(carousel) {
        var prev = document.querySelector('.pdp-gallery-arrow--prev[aria-controls="' + carousel.id + '"] button');
        var next = document.querySelector('.pdp-gallery-arrow--next[aria-controls="' + carousel.id + '"] button');
        if (!prev && !next) return;
        var cells = pdpGalleryCells(carousel);
        var idx = pdpGalleryClosestIndex(carousel, carousel.scrollLeft);
        if (prev) prev.disabled = idx <= 0;
        if (next) next.disabled = idx >= cells.length - 1;
    }

    function pdpGalleryStep(carousel, dir) {
        var cells = pdpGalleryCells(carousel);
        if (!cells.length) return;
        var idx = pdpGalleryClosestIndex(carousel, carousel.scrollLeft);
        var target = Math.min(Math.max(idx + dir, 0), cells.length - 1);
        if (target === idx) return;
        pdpGallerySyncWidths(carousel);
        carousel.scrollTo({ left: pdpGallerySnapLeft(carousel, target), behavior: 'smooth' });
    }

    function pdpGalleryInitAll() {
        var carousels = document.querySelectorAll('.product--pdp-redesign .product-gallery__carousel');
        for (var i = 0; i < carousels.length; i++) {
            var carousel = carousels[i];
            pdpGalleryResync(carousel);
            pdpGallerySyncArrows(carousel);
            if (!carousel.dataset.pdpWidthBound) {
                carousel.dataset.pdpWidthBound = '1';
                (function (c) {
                    var list = c.closest('.product-gallery__image-list') || c.parentElement;
                    if (typeof ResizeObserver !== 'undefined') {
                        new ResizeObserver(function () {
                            if (window.innerWidth < 1000) {
                                pdpGallerySyncWidths(c);
                                return;
                            }
                            pdpGalleryResync(c);
                        }).observe(list);
                    }
                    if (typeof MutationObserver !== 'undefined') {
                        new MutationObserver(function () {
                            pdpGalleryResync(c, window.innerWidth < 1000);
                            pdpGallerySyncArrows(c);
                        }).observe(c, { childList: true, attributes: true, attributeFilter: ['hidden'], subtree: false });
                    }
                    c.addEventListener('scroll', function () {
                        pdpGallerySyncArrows(c);
                    });
                })(carousel);
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', pdpGalleryInitAll);
    } else {
        pdpGalleryInitAll();
    }
    window.addEventListener('load', pdpGalleryInitAll);
    window.addEventListener('resize', pdpGalleryInitAll);

    document.addEventListener('click', function (e) {
        if (window.innerWidth < 1000) return;
        var button = e.target.closest && e.target.closest('.product--pdp-redesign .pdp-gallery-arrow button');
        if (!button || button.disabled) return;
        var host = button.closest('.pdp-gallery-arrow');
        var carousel = document.getElementById(host.getAttribute('aria-controls'));
        if (!carousel) return;
        e.preventDefault();
        e.stopPropagation();
        pdpGalleryStep(carousel, host.classList.contains('pdp-gallery-arrow--next') ? 1 : -1);
    }, true);

    document.addEventListener('dragstart', function (e) {
        if (e.target.closest && e.target.closest('.product--pdp-redesign .product-gallery__carousel')) {
            e.preventDefault();
        }
    });

    document.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (window.innerWidth < 1000) return;
        var carousel = e.target.closest && e.target.closest('.product--pdp-redesign .product-gallery__carousel');
        if (!carousel) return;
        pdpGallerySyncWidths(carousel);
        dragState = { carousel: carousel, startX: e.clientX, startLeft: carousel.scrollLeft, moved: false };
        carousel.style.scrollSnapType = 'none';
    });

    document.addEventListener('pointermove', function (e) {
        if (!dragState) return;
        var dx = e.clientX - dragState.startX;
        if (Math.abs(dx) > 5) {
            dragState.moved = true;
        }
        dragState.carousel.scrollLeft = dragState.startLeft - dx;
    });

    document.addEventListener('pointerup', function (e) {
        if (!dragState) return;
        var carousel = dragState.carousel;
        var moved = dragState.moved;
        var dx = e.clientX - dragState.startX;
        pdpGallerySyncWidths(carousel);
        var cells = pdpGalleryCells(carousel);
        var maxIndex = Math.max(0, cells.length - 1);
        var target = pdpGalleryClosestIndex(carousel, dragState.startLeft);
        if (dx < -40) {
            target = Math.min(target + 1, maxIndex);
        } else if (dx > 40) {
            target = Math.max(target - 1, 0);
        }
        carousel.scrollTo({ left: pdpGallerySnapLeft(carousel, target), behavior: 'smooth' });
        setTimeout(function () {
            carousel.style.scrollSnapType = '';
        }, 450);
        if (moved) {
            var suppress = function (ev) {
                ev.stopPropagation();
                ev.preventDefault();
                document.removeEventListener('click', suppress, true);
            };
            document.addEventListener('click', suppress, true);
            setTimeout(function () {
                document.removeEventListener('click', suppress, true);
            }, 120);
        }
        dragState = null;
    });
})();
